import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Box from '@repo/ui/box'
import Typography from '@repo/ui/typography'
import { PropsWithChildren } from 'react'

type Props = {
  title: string
}

const LabeledCard = ({ title, children }: PropsWithChildren<Props>) => {
  return (
    <Box className="bg-white border border-white-dark rounded-lg drop-shadow-xl p-0">
      <Typography
        variant="text"
        color={tailwindColors.grey.DEFAULT}
        className="border-b border-b-white-dark p-4"
      >
        {title}
      </Typography>
      {children}
    </Box>
  )
}

export default LabeledCard
